module.exports = __webpack_public_path__ + "files/c4a611f9d348f66bf390fac481ecfe9f.png";